import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { BoxBalancePage } from '@/features/box-balance/BoxBalancePage';
import { boxBalanceDestination, useDrawerCurrent } from './useCashDrawer';

/**
 * /box-balance after 2026-10-12: the box screen until the owner starts the
 * cash drawer, and the drawer from then on (see `boxBalanceDestination`).
 * The address stays so a cashier's bookmark or habit lands somewhere honest.
 */
export function BoxBalanceGate() {
  const { t } = useTranslation();
  // One read and no live tick: this only picks a screen.
  const { current, error } = useDrawerCurrent(true);
  const destination = boxBalanceDestination(current, error);

  if (destination === 'drawer') return <Navigate to="/cash-drawer" replace />;
  if (destination === 'loading') {
    return <p className="p-4 text-sm text-content-muted">{t('common.loading')}</p>;
  }
  return <BoxBalancePage />;
}
